export default __webpack_public_path__ + "static/media/notDigivakuusEligible.8c69b554.svg";